import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Button from 'components/field/Button';
import LordIcon from 'components/global/LordIcon';

import { THEME } from 'utils/Theme';
import { MODULE_PATHS } from 'utils/constants';

import { faCircleInfo, faGrid2Plus } from '@fortawesome/pro-regular-svg-icons';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

import Icon from './Icon';
import Tooltip from './Tooltip';
import Typography from './Typography';
import * as S from './styled/PageHeader.styled';

const PageHeader = ({
	lordIcon,
	title,
	subtitle,
	tooltip,
	className,
	children,
	showBackButton,
	backUrl,
	moduleName
}) => {
	const navigate = useNavigate();
	const darkMode = useSelector((state) => state.layout.darkMode);

	return (
		<S.HeaderWrapper className={className}>
			<S.HeaderRowContent>
				{showBackButton && (
					<Button
						icon={faArrowLeft}
						variant="transparent"
						color="var(--black)"
						iconSize="large"
						iconButton
						onClick={() => {
							navigate(backUrl ?? -1);
						}}
						style={{ marginLeft: '-1rem' }}
					/>
				)}

				{!showBackButton && lordIcon && (
					<LordIcon
						primaryColor={darkMode ? THEME.WHITE : THEME.BLACK}
						secondaryColor={darkMode ? THEME.DARK.PRIMARY_COLOR : THEME.LIGHT.PRIMARY_COLOR}
						src={lordIcon}
					/>
				)}

				<S.HeaderColumnContent>
					{subtitle && <Typography fontWeight="500">{subtitle}</Typography>}
					{title && (
						<Typography variant="h4" fontWeight="700">
							{title}
						</Typography>
					)}
				</S.HeaderColumnContent>

				{tooltip && (
					<Tooltip placement="bottom" title={tooltip}>
						<Icon icon={faCircleInfo} color="var(--black)" />
					</Tooltip>
				)}
				{moduleName && (
					<Tooltip
						placement="bottom"
						header={moduleName}
						title={`${moduleName}.description`}
						ctaButtonLabel="viewModuleDetails"
						ctaButtonOnClick={() => navigate(MODULE_PATHS[moduleName])}>
						<Icon icon={faGrid2Plus} color="var(--blue)" className="module-tooltip" />
					</Tooltip>
				)}
			</S.HeaderRowContent>

			{children}
		</S.HeaderWrapper>
	);
};

export default PageHeader;
